<template>
  <div>
    <div v-if="!isConnect">
      <vs-button type="filled" @click="connect()">Connect WebSocket</vs-button>
    </div>
    <div v-else>
      <vs-button type="filled" disabled>Connect!</vs-button>
      <br><br><h4>{{socketData}}</h4>
    </div>
  </div>
</template>

<script>

export default {
  data: () => ({
    isConnect: false,
    socketData: {
      battery:3.5,
      frame_format:1,
      occupancy:1,
      timestamp: ''
    },
    interval: ''
  }),
  methods: {
    connect() {
      this.isConnect = true
      console.log(this.isConnect)
      this.$vs.notify({
        title: 'Connect WebSocket',
        text: 'complete!',
        color: 'primary',
        position:'top-center'
      });
    }
  },
  async mounted() {
    this.socketData.timestamp = this.$moment().format('YYYY-MM-DD HH:mm:ss')
    this.interval = setInterval(() => {
      setTimeout(() => {
        this.socketData = {
          battery:3.5,
          frame_format: 1,
          occupancy: Math.floor(Math.random() * 2),
          timestamp: this.$moment().format('YYYY-MM-DD HH:mm:ss')
        }
      }, Math.floor(Math.random() * 10));
    }, 10000);
  },
  beforeDestroy() {
    clearInterval(this.interval)
  }
}
</script>

<style>
</style>